
export const message = {
    invalidMonthlyAmountOkComply: "validation.invalidNumber.monthlyAmountOkComply",
    invalidMonthlyAmountOkAudit: "validation.invalidNumber.monthlyAmountOkAudit",
    invalidMonthlyAmountOkPublish: "validation.invalidNumber.monthlyAmountOkPublish",
    invalidEndDate: "validation.invalid.endDate",
    invalidStartDate: "validation.invalid.startDate",
    invalidInvoiceTo: "validation.invalid.invoiceTo",
    organisationSaved: "organisation.saved.label"
};